export default {"src":"/_next/static/media/icon.473216de.svg","height":461,"width":478};